import axios from '../../v2/app/services/axiosService';
import {isObject} from 'lodash';

/**
 * MLD-3475
 */
export default {
  canViewUserInsights(user, team, presentation) { // MLD-3475
    return isObject(team)
      && team.content_enabled
      && team.analytics_enabled
      && isObject(user)
      && (user.team_admin || user.is_admin || user.team?.is_admin)
      && isObject(presentation)
      && (presentation.type_pdf || presentation.converts_to_pdf);
  },
  async getUserReport(presentationID, userID) {
    const response = await axios.get(`/api/analytics/presentations/${presentationID}/users/${userID}`);
    return response.data;
  },
  async getUsersReport(presentationID, form) {
    const options = {
      params: form,
    };
    const response = await axios.get(`/api/analytics/presentations/${presentationID}/users`, options);
    return response.data;
  },
  async getPagesReport(presentationID, form) {
    const options = {
      params: form,
    };
    const response = await axios.get(`/api/analytics/presentations/${presentationID}/users/pages`, options);
    return response.data;
  },
  async getDeviceSessions(params = {}) { // MLD-2534
    const response = await axios.get(`/api/device-sessions`, {params});
    return response.data;
  },
  async getSession(sessionID) {
    const response = await axios.get(`/api/sessions/${sessionID}`);
    return response.data;
  },
  async getDeviceEvents(form) {
    const response = await axios.get(`/api/device-events`, {params: form});
    return response.data;
  },
  async getDeviceEvent(eventID) {
    const response = await axios.get(`/api/device-events/${eventID}`);
    return response.data;
  },
}
